import { render, staticRenderFns } from "./manage-device.vue?vue&type=template&id=bd07b246&scoped=true"
import script from "./manage-device.vue?vue&type=script&lang=ts"
export * from "./manage-device.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd07b246",
  null
  
)

export default component.exports